import React from "react";
import {
  Text,
  TouchableOpacity,
  useWindowDimensions,
  ActivityIndicator,
  View,
} from "react-native";
import Hoverable from "../helpers/Hoverable";

const SimpleButton = (props) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 850;
  return (
    <Hoverable>
      {(isHovered) => (
        <TouchableOpacity
          disabled={props.analysis_loading}
          style={[
            styles.container,
            props.customStyle,
            isHovered && !props.analysis_loading && { backgroundColor: "red" },
            isMobile && {
              width: "60%",
              paddingHorizontal: 10,
              alignSelf: "center",
              height: 40,
            },
            props.analysis_loading && {
              opacity: 0.5,
            },
          ]}
          onPress={props.onPress}
        >
          {props.loading && (
            <View
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                borderRadius: 3,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#ffffff90",
              }}
            >
              <ActivityIndicator />
            </View>
          )}
          <Text style={[styles.loginText, isMobile && { fontSize: 14 }]}>
            {props.label ? props.label : "Log In To Continue"}
          </Text>
        </TouchableOpacity>
      )}
    </Hoverable>
  );
};

const styles = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    marginVertical: 10,
    backgroundColor: "rgba(232, 108, 0, 1)",
    borderRadius: 8,
  },
  loginText: {
    color: "white",
    fontFamily: "Roboto",
    fontWeight: "600",
    letterSpacing: 0.5,
    fontSize: 12,
    paddingHorizontal: "1.4em",
    paddingVertical: "1em",
  },
};

export default SimpleButton;
